import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1, e as esm} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {P as Popper} from "../../common/index-05e5b98e.js";
import {L as ListSubheader} from "../../common/index-5998a1c2.js";
import {P as Paper} from "../../common/index-ea610a7a.js";
import {I as IconButton} from "../../common/index-244f92e9.js";
import {C as Chip} from "../../common/index-9019463a.js";
import {i as inputClasses_1, a as inputBaseClasses_1, o as outlinedInputClasses_1, f as filledInputClasses_1, A as ArrowDropDown} from "../../common/ArrowDropDown-4d05c1b7.js";
import {c as createSvgIcon_1} from "../../common/createSvgIcon-ee034812.js";
import _jsxRuntime from "react/jsx-runtime";
import {u as useThemeProps_1, s as styled_1} from "../../common/useThemeProps-ef190a94.js";
import {c as capitalize} from "../../common/capitalize-0607751a.js";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/useTheme-ad5c2c5a.js";
import "../../common/index-ef2a811c.js";
import "../../common/useForkRef-b591be37.js";
import "../../common/useEventCallback-f6be53c8.js";
import "../../common/useIsFocusVisible-28d126d4.js";
import "../../common/index-639d8dc8.js";
import "../../common/Transition-8cd86cbd.js";
var Close = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  var _createSvgIcon = interopRequireDefault(createSvgIcon_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), "Close");
  exports.default = _default;
});
var autocompleteClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getAutocompleteUtilityClass = getAutocompleteUtilityClass;
  function getAutocompleteUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiAutocomplete", slot);
  }
  const autocompleteClasses = (0, core.generateUtilityClasses)("MuiAutocomplete", ["root", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
  var _default = autocompleteClasses;
  exports.default = _default;
});
var Autocomplete_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
      return core.createFilterOptions;
    }
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _Popper = interopRequireDefault(Popper);
  var _ListSubheader = interopRequireDefault(ListSubheader);
  var _Paper = interopRequireDefault(Paper);
  var _IconButton = interopRequireDefault(IconButton);
  var _Chip = interopRequireDefault(Chip);
  var _inputClasses = interopRequireDefault(inputClasses_1);
  var _inputBaseClasses = interopRequireDefault(inputBaseClasses_1);
  var _outlinedInputClasses = interopRequireDefault(outlinedInputClasses_1);
  var _filledInputClasses = interopRequireDefault(filledInputClasses_1);
  var _Close = interopRequireDefault(Close);
  var _ArrowDropDown = interopRequireDefault(ArrowDropDown);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _styled = interopRequireDefault(styled_1);
  var _autocompleteClasses = _interopRequireWildcard(autocompleteClasses_1);
  var _capitalize = interopRequireDefault(capitalize);
  var _ClearIcon, _ArrowDropDownIcon;
  const _excluded = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      disablePortal,
      focused,
      fullWidth,
      hasClearIcon,
      hasPopupIcon,
      inputFocused,
      popupOpen,
      size
    } = ownerState;
    const slots = {
      root: ["root", focused && "focused", fullWidth && "fullWidth", hasClearIcon && "hasClearIcon", hasPopupIcon && "hasPopupIcon"],
      inputRoot: ["inputRoot"],
      input: ["input", inputFocused && "inputFocused"],
      tag: ["tag", `tagSize${(0, _capitalize.default)(size)}`],
      endAdornment: ["endAdornment"],
      clearIndicator: ["clearIndicator"],
      popupIndicator: ["popupIndicator", popupOpen && "popupIndicatorOpen"],
      popper: ["popper", disablePortal && "popperDisablePortal"],
      paper: ["paper"],
      listbox: ["listbox"],
      loading: ["loading"],
      noOptions: ["noOptions"],
      option: ["option"],
      groupLabel: ["groupLabel"],
      groupUl: ["groupUl"]
    };
    return (0, core.unstable_composeClasses)(slots, _autocompleteClasses.getAutocompleteUtilityClass, classes);
  };
  const AutocompleteRoot = (0, _styled.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      const {
        fullWidth,
        hasClearIcon,
        hasPopupIcon,
        inputFocused,
        size
      } = ownerState;
      return [{
        [`& .${_autocompleteClasses.default.tag}`]: styles.tag
      }, {
        [`& .${_autocompleteClasses.default.tag}`]: styles[`tagSize${(0, _capitalize.default)(size)}`]
      }, {
        [`& .${_autocompleteClasses.default.inputRoot}`]: styles.inputRoot
      }, {
        [`& .${_autocompleteClasses.default.input}`]: styles.input
      }, {
        [`& .${_autocompleteClasses.default.input}`]: inputFocused && styles.inputFocused
      }, styles.root, fullWidth && styles.fullWidth, hasPopupIcon && styles.hasPopupIcon, hasClearIcon && styles.hasClearIcon];
    }
  })(({
    ownerState
  }) => (0, _extends2.default)({
    [`&.${_autocompleteClasses.default.focused} .${_autocompleteClasses.default.clearIndicator}`]: {
      visibility: "visible"
    },
    "@media (pointer: fine)": {
      [`&:hover .${_autocompleteClasses.default.clearIndicator}`]: {
        visibility: "visible"
      }
    }
  }, ownerState.fullWidth && {
    width: "100%"
  }, {
    [`& .${_autocompleteClasses.default.tag}`]: (0, _extends2.default)({
      margin: 3,
      maxWidth: "calc(100% - 6px)"
    }, ownerState.size === "small" && {
      margin: 2,
      maxWidth: "calc(100% - 4px)"
    }),
    [`& .${_autocompleteClasses.default.inputRoot}`]: {
      flexWrap: "wrap",
      [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
        paddingRight: 26 + 4
      },
      [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
        paddingRight: 52 + 4
      },
      [`& .${_autocompleteClasses.default.input}`]: {
        width: 0,
        minWidth: 30
      }
    },
    [`& .${_inputClasses.default.root}`]: {
      paddingBottom: 1,
      "& .MuiInput-input": {
        padding: "4px 4px 4px 0px"
      }
    },
    [`& .${_inputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
      [`& .${_inputClasses.default.input}`]: {
        padding: "2px 4px 3px 0"
      }
    },
    [`& .${_outlinedInputClasses.default.root}`]: {
      padding: 9,
      [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
        paddingRight: 26 + 4 + 9
      },
      [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
        paddingRight: 52 + 4 + 9
      },
      [`& .${_autocompleteClasses.default.input}`]: {
        padding: "7.5px 4px 7.5px 6px"
      },
      [`& .${_autocompleteClasses.default.endAdornment}`]: {
        right: 9
      }
    },
    [`& .${_outlinedInputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
      padding: 6,
      [`& .${_autocompleteClasses.default.input}`]: {
        padding: "2.5px 4px 2.5px 6px"
      }
    },
    [`& .${_filledInputClasses.default.root}`]: {
      paddingTop: 19,
      paddingLeft: 8,
      [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
        paddingRight: 26 + 4 + 9
      },
      [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
        paddingRight: 52 + 4 + 9
      },
      [`& .${_filledInputClasses.default.input}`]: {
        padding: "7px 4px"
      },
      [`& .${_autocompleteClasses.default.endAdornment}`]: {
        right: 9
      }
    },
    [`& .${_filledInputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
      paddingBottom: 1,
      [`& .${_filledInputClasses.default.input}`]: {
        padding: "2.5px 4px"
      }
    },
    [`& .${_autocompleteClasses.default.input}`]: (0, _extends2.default)({
      flexGrow: 1,
      textOverflow: "ellipsis",
      opacity: 0
    }, ownerState.inputFocused && {
      opacity: 1
    })
  }));
  const AutocompleteEndAdornment = (0, _styled.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles) => styles.endAdornment
  })({
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)"
  });
  const AutocompleteClearIndicator = (0, _styled.default)(_IconButton.default, {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles) => styles.clearIndicator
  })({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
  });
  const AutocompletePopupIndicator = (0, _styled.default)(_IconButton.default, {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({
      ownerState
    }, styles) => (0, _extends2.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
  })(({
    ownerState
  }) => (0, _extends2.default)({
    padding: 2,
    marginRight: -2
  }, ownerState.popupOpen && {
    transform: "rotate(180deg)"
  }));
  const AutocompletePopper = (0, _styled.default)(_Popper.default, {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [{
        [`& .${_autocompleteClasses.default.option}`]: styles.option
      }, styles.popper, ownerState.disablePortal && styles.popperDisablePortal];
    }
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    zIndex: theme.zIndex.modal
  }, ownerState.disablePortal && {
    position: "absolute"
  }));
  const AutocompletePaper = (0, _styled.default)(_Paper.default, {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles) => styles.paper
  })(({
    theme
  }) => (0, _extends2.default)({}, theme.typography.body1, {
    overflow: "auto"
  }));
  const AutocompleteLoading = (0, _styled.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles) => styles.loading
  })(({
    theme
  }) => ({
    color: theme.palette.text.secondary,
    padding: "14px 16px"
  }));
  const AutocompleteNoOptions = (0, _styled.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles) => styles.noOptions
  })(({
    theme
  }) => ({
    color: theme.palette.text.secondary,
    padding: "14px 16px"
  }));
  const AutocompleteListbox = (0, _styled.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles) => styles.listbox
  })(({
    theme
  }) => ({
    listStyle: "none",
    margin: 0,
    padding: "8px 0",
    maxHeight: "40vh",
    overflow: "auto",
    [`& .${_autocompleteClasses.default.option}`]: {
      minHeight: 48,
      display: "flex",
      overflow: "hidden",
      justifyContent: "flex-start",
      alignItems: "center",
      cursor: "pointer",
      paddingTop: 6,
      boxSizing: "border-box",
      outline: "0",
      WebkitTapHighlightColor: "transparent",
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16,
      [theme.breakpoints.up("sm")]: {
        minHeight: "auto"
      },
      [`&.${_autocompleteClasses.default.focused}`]: {
        backgroundColor: theme.palette.action.hover,
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      '&[aria-disabled="true"]': {
        opacity: theme.palette.action.disabledOpacity,
        pointerEvents: "none"
      },
      [`&.${_autocompleteClasses.default.focusVisible}`]: {
        backgroundColor: theme.palette.action.focus
      },
      '&[aria-selected="true"]': {
        backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        [`&.${_autocompleteClasses.default.focused}`]: {
          backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: theme.palette.action.selected
          }
        },
        [`&.${_autocompleteClasses.default.focusVisible}`]: {
          backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
      }
    }
  }));
  const AutocompleteGroupLabel = (0, _styled.default)(_ListSubheader.default, {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles) => styles.groupLabel
  })(({
    theme
  }) => ({
    backgroundColor: theme.palette.background.paper,
    top: -8
  }));
  const AutocompleteGroupUl = (0, _styled.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles) => styles.groupUl
  })({
    padding: 0,
    [`& .${_autocompleteClasses.default.option}`]: {
      paddingLeft: 24
    }
  });
  const Autocomplete2 = /* @__PURE__ */ React$1.forwardRef(function Autocomplete3(inProps, ref) {
    var _componentsProps$clea;
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiAutocomplete"
    });
    const {
      autoComplete = false,
      autoHighlight = false,
      autoSelect = false,
      blurOnSelect = false,
      ChipProps,
      className,
      clearIcon = _ClearIcon || (_ClearIcon = /* @__PURE__ */ (0, _jsxRuntime.jsx)(_Close.default, {
        fontSize: "small"
      })),
      clearOnBlur = !props.freeSolo,
      clearOnEscape = false,
      clearText = "Clear",
      closeText = "Close",
      componentsProps = {},
      defaultValue = props.multiple ? [] : null,
      disableClearable = false,
      disableCloseOnSelect = false,
      disabled = false,
      disabledItemsFocusable = false,
      disableListWrap = false,
      disablePortal = false,
      filterSelectedOptions = false,
      forcePopupIcon = "auto",
      freeSolo = false,
      fullWidth = false,
      getLimitTagsText = (more) => `+${more}`,
      getOptionLabel = (option) => {
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
      },
      groupBy,
      handleHomeEndKeys = !props.freeSolo,
      includeInputInList = false,
      limitTags = -1,
      ListboxComponent = "ul",
      ListboxProps,
      loading = false,
      loadingText = "Loading…",
      multiple = false,
      noOptionsText = "No options",
      openOnFocus = false,
      openText = "Open",
      PaperComponent = _Paper.default,
      PopperComponent = _Popper.default,
      popupIcon = _ArrowDropDownIcon || (_ArrowDropDownIcon = /* @__PURE__ */ (0, _jsxRuntime.jsx)(_ArrowDropDown.default, {})),
      renderGroup: renderGroupProp,
      renderInput,
      renderOption: renderOptionProp,
      renderTags,
      selectOnFocus = !props.freeSolo,
      size = "medium"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const {
      getRootProps,
      getInputProps,
      getInputLabelProps,
      getPopupIndicatorProps,
      getClearProps,
      getTagProps,
      getListboxProps,
      getOptionProps,
      value,
      dirty,
      id,
      popupOpen,
      focused,
      focusedTag,
      anchorEl,
      setAnchorEl,
      inputValue,
      groupedOptions
    } = (0, core.useAutocomplete)((0, _extends2.default)({}, props, {
      componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const ownerState = (0, _extends2.default)({}, props, {
      disablePortal,
      focused,
      fullWidth,
      hasClearIcon,
      hasPopupIcon,
      inputFocused: focusedTag === -1,
      popupOpen,
      size
    });
    const classes = useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
      const getCustomizedTagProps = (params) => (0, _extends2.default)({
        className: (0, _clsx.default)(classes.tag),
        disabled
      }, getTagProps(params));
      if (renderTags) {
        startAdornment = renderTags(value, getCustomizedTagProps);
      } else {
        startAdornment = value.map((option, index) => /* @__PURE__ */ (0, _jsxRuntime.jsx)(_Chip.default, (0, _extends2.default)({
          label: getOptionLabel(option),
          size
        }, getCustomizedTagProps({
          index
        }), ChipProps)));
      }
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
      const more = startAdornment.length - limitTags;
      if (!focused && more > 0) {
        startAdornment = startAdornment.splice(0, limitTags);
        startAdornment.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
          className: classes.tag,
          children: getLimitTagsText(more)
        }, startAdornment.length));
      }
    }
    const defaultRenderGroup = (params) => /* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
      children: [/* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompleteGroupLabel, {
        className: classes.groupLabel,
        ownerState,
        component: "div",
        children: params.group
      }), /* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompleteGroupUl, {
        className: classes.groupUl,
        ownerState,
        children: params.children
      })]
    }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option) => /* @__PURE__ */ (0, _jsxRuntime.jsx)("li", (0, _extends2.default)({}, props2, {
      children: getOptionLabel(option)
    }));
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index) => {
      const optionProps = getOptionProps({
        option,
        index
      });
      return renderOption((0, _extends2.default)({}, optionProps, {
        className: classes.option
      }), option, {
        selected: optionProps["aria-selected"],
        inputValue
      });
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(React$1.Fragment, {
      children: [/* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompleteRoot, (0, _extends2.default)({
        ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState
      }, getRootProps(other), {
        children: renderInput({
          id,
          disabled,
          fullWidth: true,
          size: size === "small" ? "small" : void 0,
          InputLabelProps: getInputLabelProps(),
          InputProps: {
            ref: setAnchorEl,
            className: classes.inputRoot,
            startAdornment,
            endAdornment: /* @__PURE__ */ (0, _jsxRuntime.jsxs)(AutocompleteEndAdornment, {
              className: classes.endAdornment,
              ownerState,
              children: [hasClearIcon ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompleteClearIndicator, (0, _extends2.default)({}, getClearProps(), {
                "aria-label": clearText,
                title: clearText,
                ownerState
              }, componentsProps.clearIndicator, {
                className: (0, _clsx.default)(classes.clearIndicator, (_componentsProps$clea = componentsProps.clearIndicator) == null ? void 0 : _componentsProps$clea.className),
                children: clearIcon
              })) : null, hasPopupIcon ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompletePopupIndicator, (0, _extends2.default)({}, getPopupIndicatorProps(), {
                disabled,
                "aria-label": popupOpen ? closeText : openText,
                title: popupOpen ? closeText : openText,
                className: (0, _clsx.default)(classes.popupIndicator),
                ownerState,
                children: popupIcon
              })) : null]
            })
          },
          inputProps: (0, _extends2.default)({
            className: (0, _clsx.default)(classes.input),
            disabled
          }, getInputProps())
        })
      })), popupOpen && anchorEl ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompletePopper, {
        as: PopperComponent,
        className: (0, _clsx.default)(classes.popper),
        disablePortal,
        style: {
          width: anchorEl ? anchorEl.clientWidth : null
        },
        ownerState,
        role: "presentation",
        anchorEl,
        open: true,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)(AutocompletePaper, {
          as: PaperComponent,
          className: classes.paper,
          ownerState,
          children: [loading && groupedOptions.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompleteLoading, {
            className: classes.loading,
            ownerState,
            children: loadingText
          }) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompleteNoOptions, {
            className: classes.noOptions,
            ownerState,
            role: "presentation",
            onMouseDown: (event) => {
              event.preventDefault();
            },
            children: noOptionsText
          }) : null, groupedOptions.length > 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(AutocompleteListbox, (0, _extends2.default)({
            as: ListboxComponent,
            className: classes.listbox,
            ownerState
          }, getListboxProps(), ListboxProps, {
            children: groupedOptions.map((option, index) => {
              if (groupBy) {
                return renderGroup({
                  key: option.key,
                  group: option.group,
                  children: option.options.map((option2, index2) => renderListOption(option2, option.index + index2))
                });
              }
              return renderListOption(option, index);
            })
          })) : null]
        })
      }) : null]
    });
  });
  var _default = Autocomplete2;
  exports.default = _default;
});
var Autocomplete = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    createFilterOptions: true,
    autocompleteClasses: true
  };
  Object.defineProperty(exports, "autocompleteClasses", {
    enumerable: true,
    get: function() {
      return _autocompleteClasses.default;
    }
  });
  Object.defineProperty(exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
      return _Autocomplete.createFilterOptions;
    }
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Autocomplete.default;
    }
  });
  var _Autocomplete = _interopRequireWildcard(Autocomplete_1);
  var _autocompleteClasses = _interopRequireWildcard(autocompleteClasses_1);
  Object.keys(_autocompleteClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _autocompleteClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _autocompleteClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Autocomplete);
export default __pika_web_default_export_for_treeshaking__;
